import {Component, Input, OnChanges} from '@angular/core';
import {GroupResponseDto} from "../../../dto/group.response.dto";
import {DataFeatureResponseDto} from "../../../dto/data.feature.response.dto";

@Component({
  selector: 'app-property-features',
  templateUrl: './property-features.component.html',
  styleUrls: ['./property-features.component.scss']
})
export class PropertyFeaturesComponent implements OnChanges {
    @Input() featureGroups: GroupResponseDto[] = [];

    paginatedGroups: {
        groupId: number;
        groupLabel: string;
        visible: DataFeatureResponseDto[];
        all: DataFeatureResponseDto[];
        currentPage: number;
    }[] = [];

    pageSize = 10;

    /** Re-mapea cuando el @Input cambia (los datos llegan async vía facade). */
    ngOnChanges(): void {
        this.paginatedGroups = (this.featureGroups ?? []).map(group => ({
            groupId: group.groupId,
            groupLabel: group.groupLabel,
            all: group.featureList,
            visible: group.featureList.slice(0, this.pageSize),
            currentPage: 1
        }));
    }

    loadMore(group: any): void {
        const start = group.currentPage * this.pageSize;
        const next = group.all.slice(start, start + this.pageSize);
        group.visible = [...group.visible, ...next];
        group.currentPage++;
    }

    hasMore(group: any): boolean {
        return group.visible.length < group.all.length;
    }
}
